/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrichedVirtualArticle } from '../../models/enriched-virtual-article';
import { KeyType } from '../../models/key-type';
import { VirtualArticleAddRequest } from '../../models/virtual-article-add-request';

export interface AddBundleGroupVirtualArticle$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
      body: VirtualArticleAddRequest
}

export function addBundleGroupVirtualArticle(http: HttpClient, rootUrl: string, params: AddBundleGroupVirtualArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<EnrichedVirtualArticle>> {
  const rb = new RequestBuilder(rootUrl, addBundleGroupVirtualArticle.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EnrichedVirtualArticle>;
    })
  );
}

addBundleGroupVirtualArticle.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/edit';
